export class UserChangedMessage {
  constructor(public successfull: boolean) {
  }
}
